import http from 'hub-http/clients/apiClient';
export function fetchCloneInfoRequest(emailId, checkIfConvertibleToDragAndDrop) {
  const url = `cosemail/v1/emails/${emailId}/clone-information`;
  return http.get(url, {
    query: {
      checkIfConvertibleToDragAndDrop
    }
  });
}